<template>
  <div class="page-container">
    <div class="query-title">存新酒客户查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="新增" @click="dialogVisible=true" />
            <table-button name="export" tip="删除" @click="handleDelete" />
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          />
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />
    <el-dialog
      title="新增"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <ClientSelect ref="dialogSelect" :isRadio="isRadio"/>
      <div slot="footer">
        <el-button size="small" type="default" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { apiCxjBpMod } from '@/api/sap/client-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig from './config/newWineCustomer'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  components: { ClientSelect },
  data() {
    return {
      isRadio: false,
      dialogVisible: false,
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 }
        ],
        data: []
      },
      searchField: {},
      isSetFilter: false,
      editRows: [],
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    // 导出全部 导出本页
    async exportExcel() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (checkData.length) {
        frontExport(this.gridOptions.columns, checkData, '存新酒客户数据报表')
        return
      }
      const params = {
        mode: 'SELECT',
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, apiCxjBpMod)
      frontExport(this.gridOptions.columns, data, '存新酒客户数据报表')
    },
    async submitHandle(){
      const data = await this.$refs.dialogSelect.submitForm()
      console.log(`output-data`,data)
      const addArr = []
      data.forEach(ele => {
        addArr.push({
          partner: ele.partner,
          name: ele.name_org1,
        })
      });
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        mode: 'INSERT',
        data: addArr
      }
      const res = await apiCxjBpMod(params)
      if(res.msgtype === 'S'){
        this.dialogVisible = false
        Message.success('添加成功')
        this.queryData()
      }else{
        return Message.warning(res.message)
      }
    },
    async handleDelete(){
      const data = this.$refs.xTable.getCheckboxRecords()
      if(!data.length){
        return Message.warning('请选择删除数据！')
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        mode: 'DELETE',
        data
      }
      const res = await apiCxjBpMod(params)
      debugger
      if(res.msgtype === 'S'){
        Message.success('删除成功')
        this.queryData()
      }else{
        return Message.warning(res.message)
      }
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        mode: 'SELECT',
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiCxjBpMod(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/newWineCustomer.vue